import React, { Component } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Card,
	CardContent,
	Button,
	Typography,
    Checkbox,
} from '@material-ui/core';
import {
	HomeOutlined as HomeIcon
} from '@material-ui/icons';

import { MyPATLocalLoader } from '../../common';
import cx from 'classnames';
import GoalDrillerData from '../../mylibrary/types/GoalDrillerData';
import CourseData from '../../mylibrary/types/CourseData';
import CourseSyllabusData from '../../mylibrary/types/CourseSyllabusData';
import courseService from '../../mylibrary/services/courseService';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { connect } from 'react-redux';
import {styles} from '../styling/component/GoalsDriller'

//@ts-ignore
interface GoalsDrillerProps extends WithStyles<typeof styles> {
	classes: any,
	goalsDriller: GoalDrillerData,
    //goaldsDrillerChanged: Function,
    setCourseData:Function,
    addSubjectConcept:Function,
    courseData:any,
    handleCheckboxChange:Function
}

interface GoalsDrillerState {
	loading: boolean,
	goalsDriller: GoalDrillerData,
	keyToShow: string,
	keyIdToShow: string,
	parentId: string,
	courses: CourseData[],
	subjects: {
		[key: string]: CourseSyllabusData[]
	},
	subSubjects: {
		[key: string]: CourseSyllabusData[]
	},
	chapters: {
		[key: string]: CourseSyllabusData[]
	},
	concepts: {
		[key: string]: CourseSyllabusData[]
	},
	dataLength: number,
	[key: string]: any
}


class GoalsDriller extends Component<GoalsDrillerProps, GoalsDrillerState>{
	initialLevel: string = ""

	constructor(props: GoalsDrillerProps) {
		super(props);

		let keyIdToShow = "";
		let keyToShow = "";

		//set preselected goal filter
		props =
			{
				...props,
				goalsDriller:
				{
					level: "course",
					course: {
						_id: "",
						name: "",
						courseItems: [],
						childCount: 0
					},
					subject: {
						_id: "",
						name: "",
						childCount: 0
					},
					subSubject: {
						_id: "",
						name: "",
						childCount: 0
					},
					chapter: {
						_id: "",
						name: "",
						childCount: 0
					},
					concept: {
						_id: "",
						name: "",
						childCount: 0
					},
					...props.goalsDriller,
				}
			}


		if (props.goalsDriller.level == "subject") {
			keyIdToShow = props.goalsDriller.course._id;
			keyToShow = "subjects";
		} else if (props.goalsDriller.level == "sub-subject") {
			keyIdToShow = props.goalsDriller.course._id;
			keyToShow = "subjects";
		} else if (props.goalsDriller.level == "chapter") {
			keyToShow = "chapters";
			keyIdToShow = props.goalsDriller.subSubject._id;
		} else if (props.goalsDriller.level == "concept") {
			keyToShow = "concepts";
			keyIdToShow = props.goalsDriller.chapter._id;
		}

		this.state = {
			...this.state,
			loading: false,
			collapseOnScroll: false,
			keyToShow: keyToShow,
			keyIdToShow: keyIdToShow,
			parentId: "",
			subjects: {},
			subSubjects: {},
			chapters: {},
			concepts: {},
			dataLength: 0,
			goalsDriller: props.goalsDriller
		}

		this.initialLevel = props.goalsDriller.level;
		this.loadNext = this.loadNext.bind(this);
		this.renderChip = this.renderChip.bind(this);
		this.goForNextLevel = this.goForNextLevel.bind(this);
		this.getSelectedLevel = this.getSelectedLevel.bind(this);
	}

	componentDidMount() {
		this.loadNext(_.get(this.props, "goalsDriller.level", "course"))
	///	this.addScrollEvent();
	}

	componentWillUnmount() {
	//	this.removeScrollEvent();
	}

    
	loadNext(level: string = "course") {
        let { goalsDriller, courses, subjects, subSubjects, chapters, concepts } = this.state;
        let {courseData} = this.props
		let keyToShow = "";
		let keyIdToShow = "";
		let dataLength = 0;
		let nextLevel = "";
		let result: any[] = [];

		return Promise.resolve()
			.then(() => {
				//set loader
				this.setState({ loading: true });

				return Promise.resolve();
			})
			.then((): any => {
				if (level == "course") {
					goalsDriller.level = "course";
					nextLevel = "subject";
					keyToShow = "courses";
					if (!courses) {
						if(courseData==""){
                            courseData =  JSON.parse(localStorage.getItem("myPatCourse") || "")
                        }
                        return Promise.resolve(courseData.goals);
						
					} else {
						return Promise.resolve(courses);
					}
				} else if (level == "subject") {
					goalsDriller.level = "subject";
					nextLevel = "sub-subject";
					keyToShow = "subjects";
					keyIdToShow = goalsDriller.course._id;
					if (!subjects[keyIdToShow]) {
						return courseService.getCourseSubject(goalsDriller.course._id)
							.then((res: CourseSyllabusData[]) => {
								return Promise.resolve(res);
							});
					} else {
						return Promise.resolve(subjects[keyIdToShow]);
					}
				} else if (level == "sub-subject") {
					goalsDriller.level = "sub-subject";
					nextLevel = "chapter";
					keyToShow = "subSubjects";
					keyIdToShow = goalsDriller.subject._id;
					if (!subSubjects[keyIdToShow]) {
						return courseService.getCourseSubSubject(goalsDriller.course._id, goalsDriller.subject._id)
							.then((res: CourseSyllabusData[]) => {
								return Promise.resolve(res);
							});
					} else {
						return Promise.resolve(subSubjects[keyIdToShow]);
					}
				} else if (level == "chapter") {
					goalsDriller.level = "chapter";
					nextLevel = "concept";
					keyToShow = "chapters";
					keyIdToShow = goalsDriller.subSubject._id;
					if (!chapters[keyIdToShow]) {
						return courseService.getCourseChapters(goalsDriller.course._id, goalsDriller.subSubject._id)
							.then((res: CourseSyllabusData[]) => {
								return Promise.resolve(res);
							});
					} else {
						return Promise.resolve(chapters[keyIdToShow]);
					}
				} else if (level == "concept") {
					goalsDriller.level = "concept";
					nextLevel = "";
					keyToShow = "concepts";
					keyIdToShow = goalsDriller.chapter._id;
					if (!concepts[keyIdToShow]) {
						return courseService.getCourseConcepts(goalsDriller.course._id, goalsDriller.subject._id, goalsDriller.chapter._id)
							.then((res: CourseSyllabusData[]) => {
								return Promise.resolve(res);
							});
					} else {
						return Promise.resolve(concepts[keyIdToShow]);
					}
				}

				return Promise.resolve(this.state.concepts[keyIdToShow]);
			})
			.then((res: any[]) => {
				result = res;
				dataLength = result.length;

				//if count is already loaded then don't load again
				if (dataLength > 0 && (result[0].childCount || result[0].childCount == 0)) {
					return Promise.resolve([]);
				}

				if (goalsDriller.level == "concept") {
					return Promise.resolve([]);
				}

				//create promise of all count
				let course = goalsDriller.course;
				let promises: any[] = [];
				promises = _.map(res, c => {
					let parentId = c._id;
					if (goalsDriller.level == "course") {
						course = c;
						parentId = "";
					}
					return courseService.getCountByType(nextLevel, course._id, parentId);
				});

				return Promise.all(promises);
			}).then((counts: any[]) => {
				//set all result to array
				counts.forEach((c, i) => {
					result[i].childCount = c;
				});

				//if not course update index
				let data = this.state[keyToShow];
				if (level == "course") {
					data = result
				} else {
					data[keyIdToShow] = result
				}

				//set the state of 
				this.setState({ [keyToShow]: data, keyToShow, keyIdToShow, dataLength });
			})
			.then(() => {
				this.setState({ goalsDriller });


				//set loader
				this.setState({ loading: false });
			});
	}

	goForNextLevel(c: any) {
		const { goalsDriller } = this.state;
		let level: string = "";

		if (goalsDriller.level == "course") {
			goalsDriller.course = c;
			level = "subject";
		} else if (goalsDriller.level == "subject") {
			goalsDriller.subject = c;
			level = "sub-subject";
		} else if (goalsDriller.level == "sub-subject") {
			goalsDriller.subSubject = c;
			level = "chapter";
		} else if (goalsDriller.level == "chapter") {
			goalsDriller.chapter = c;
			level = "concept";
		} else {
			goalsDriller.concept = c;

		}

		if (goalsDriller.level != level) {
			if (goalsDriller.level != "concept") {
				this.loadNext(level);
			}
			this.setState({ goalsDriller });
			// if (this.props.goaldsDrillerChanged) {
			// 	this.props.goaldsDrillerChanged(goalsDriller);
			// }
		}
	}

	getSelectedLevel(level: string) {
		const { goalsDriller } = this.state;

		//check if pre selected filter set then don't allow to override it.
		if (this.initialLevel != "course") {
			if (level == "course") {
				return;
			} else if (level == "subject") {
				if (!["course", "subject"].includes(this.initialLevel)) {
					return true;
				}
			} else if (level == "sub-subject") {
				if (!["course", "subject", "sub-subject"].includes(this.initialLevel)) {
					return true;
				}
			} else if (level == "chapter") {
				if (!["course", "subject", "sub-subject", "chapter"].includes(this.initialLevel)) {
					return true;
				}
			} else {
				if (!["course", "subject", "sub-subject", "chapter", "concept"].includes(this.initialLevel)) {
					return true;
				}
			}
		}

		//default state
		let d = {
			_id: "",
			name: "",
			childCount: 0
		};

		if (level == "course") {
			goalsDriller.course = Object.assign({}, { ...d, courseItems: [],groupId:"",courseType:{name:""}});
			goalsDriller.subject = Object.assign({}, d);
			goalsDriller.subSubject = Object.assign({}, d);
			goalsDriller.chapter = Object.assign({}, d);
			goalsDriller.concept = Object.assign({}, d);
		} else if (level == "subject") {
			goalsDriller.subject = Object.assign({}, d);
			goalsDriller.subSubject = Object.assign({}, d);
			goalsDriller.chapter = Object.assign({}, d);
			goalsDriller.concept = Object.assign({}, d);
		} else if (level == "sub-subject") {
			goalsDriller.subSubject = Object.assign({}, d);
			goalsDriller.chapter = Object.assign({}, d);
			goalsDriller.concept = Object.assign({}, d);
		} else if (level == "chapter") {
			goalsDriller.chapter = Object.assign({}, d);
			goalsDriller.concept = Object.assign({}, d);
		} else {
			goalsDriller.concept = Object.assign({}, d);
		}
		this.setState({ goalsDriller });
		//this.props.goaldsDrillerChanged(goalsDriller);

		this.loadNext(level);
	}

	renderChip() {
		const { classes,handleCheckboxChange } = this.props;
		const { goalsDriller, keyToShow, keyIdToShow, parentId} = this.state;

		let course = goalsDriller.course;
		let data = this.state[keyToShow];
		if (goalsDriller.level != "course") {
			data = data[keyIdToShow];
		}
		return _.map(data, (c: any, i: number) => {

			if (!c.childCount && c.childCount != 0) {
				c.childCount = "";
			}

			if (goalsDriller.level == "course") {
				course = c;
			}

			if (c.childCount == "" && goalsDriller.level != "concept") {
			}

			return (
				<li key={i} className={classes.chaptersDiv} >
                    {
                        goalsDriller.level != "course" && <Checkbox
                        onChange={(e)=>handleCheckboxChange(e)}
                        defaultChecked={false}
                        value={c.name}
                        key={goalsDriller.level+i}
						className={cx(classes.floatLeft)}
						classes={{
							root: classes.checkboxCSS,
							checked: classes.checked,
						}} 
                    />
                    }
                    <span onClick={() => { this.goForNextLevel(c) }} className={ goalsDriller.level != "course" ? classes.floatLeftText: classes.floatleftCourse}>
                        {c.name} {goalsDriller.level !="concept" ? <ChevronRight className={classes.icons}/>:""}
                     </span>
				</li>
			)
		})
	}

	handleScroll() {
		let { collapseOnScroll } = this.state;
		if (window.scrollY > 10 && !collapseOnScroll) {
			this.setState({ collapseOnScroll: true })
		} else if (window.scrollY < 10 && collapseOnScroll) {
			this.setState({ collapseOnScroll: false })
		}
	}

	addScrollEvent() {
		window.addEventListener('scroll', this.handleScroll.bind(this));
	}

	removeScrollEvent() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	render() {
		const { classes } = this.props;
		const { goalsDriller, keyToShow, keyIdToShow, dataLength, loading, collapseOnScroll } = this.state;
		

		return (

			<Card className={classes.marginBottom2x}>

				{
					//show local loader if loading goals
					loading ? <MyPATLocalLoader /> : ""
				}

				<CardContent className={classes.cardContentRoot}>

					<ul className={classes.ulDefault}>
						{
							(_.isEmpty(goalsDriller.course._id) ? "" : (
								<>
									<li className={classes.listItem}>
										<a onClick={(e) => { e.preventDefault(); this.getSelectedLevel("course"); }} className={classes.linkItem}>
											<HomeIcon className={classes.iconBreads}/>
										</a>
									</li>
									<li className={cx(classes.listItem,classes.marginLeft5)}>
										<a onClick={(e) => { e.preventDefault(); this.getSelectedLevel("subject"); }} className={classes.linkItem}>
											{goalsDriller.course.name}
										</a>
									</li>
								</>
							))
						}
						{
							(_.isEmpty(goalsDriller.subject._id) ? "" : (
								<li className={classes.listItem}>
									<a onClick={(e) => { e.preventDefault(); this.getSelectedLevel("sub-subject"); }} className={classes.linkItem}>
										<ChevronRight className={classes.iconBreads}/> {`Subjects (${goalsDriller.subject.childCount})`}
									</a>
								</li>
							))
						}
						{
							(_.isEmpty(goalsDriller.subSubject._id) ? "" : (
								<li className={classes.listItem}>
									<a onClick={(e) => { e.preventDefault(); this.getSelectedLevel("chapter"); }} className={classes.linkItem}>
										<ChevronRight className={classes.iconBreads}/> {`Sub Subjects (${goalsDriller.subSubject.childCount})`}
									</a>
								</li>
							))
						}
						{
							(_.isEmpty(goalsDriller.chapter._id) ? "" : (
								<li className={classes.listItem}>
									<a onClick={(e) => { e.preventDefault(); this.getSelectedLevel("concept"); }} className={classes.linkItem}>
										<ChevronRight className={classes.iconBreads}/> {`Chapters (${goalsDriller.chapter.childCount})`}
									</a>
								</li>
							))
						}
						{
							(_.isEmpty(goalsDriller.concept._id) ? "" : (
								<li className={classes.listItem}>
									<a onClick={(e) => { e.preventDefault(); }} className={classes.linkItem}>
										<ChevronRight className={classes.iconBreads}/> {`Concepts`}
									</a>
								</li>
							))
						}

					</ul>
					<ul className={classes.padding0}>
						{
							this.renderChip()
						}
					</ul>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state: any) => ({
	courseData: state.courseData.courseData.list
});

// @ts-ignore
export default connect(mapStateToProps, null)(withStyles(styles)(GoalsDriller));



